import React from "react";
import InputComponent from "V2.0/components/InputComponent.jsx";

function Form({ data, error, handleChange, template, className="h-full gap-8" }) {
  return (
    <div className={`flex flex-col ${className}`}>
      {template.map((item, index) => {
        const {
          name,
          label,
          placeholder,
          style,
          options,
          arrayLength,
          description,
          min,
          max,
          defaultValue,
          step,
          type,
          disabled,
          info
        } = item;

        return (
          <div className="h-full flex-1 w-full">
            <InputComponent
              key={index}
              name={name}
              value={data[name]}
              label={label}
              type={type}
              placeholder={placeholder}
              onChange={handleChange}
              error={error[name]}
              style={style}
              options={options}
              arrayLength={arrayLength}
              description={description}
              min={min}
              max={max}
              defaultValue={defaultValue}
              step={step}
              disabled={disabled}
              info={info}
            />
          </div>
        );
      })}
    </div>
  );
}

export default Form;
